import { useState } from "react";
import { SummaryOverviewItems } from "./summary_overview_items";
import { SummaryForm } from "./summary_form";

export const SummaryOverview = (props) => {
  const [showDiscountedPrice, setShowDiscountedPrice] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);

  function form() {
    return (
      <div style={{ borderTop: "1px solid #E9E9E9" }}>
        <h4
          style={{
            fontSize: 23,
            paddingTop: 30,
            textAlign: "center",
            fontWeight: 400,
            letterSpacing: 0,
          }}
        >
          Sestavený set si můžete zaslat e-mailem, aby se vám nikam nezatoulal
        </h4>

        <SummaryForm
          stepChange={props.stepChange}
          discountedTotalPrice={props.discountedTotalPrice}
          totalPrice={props.totalPrice}
        />
      </div>
    );
  }

  function finishButton() {
    return (
      <div className="step-buttons">
        <div
          className="button button-primary with-arrow-right"
          style={{
            fontWeight: "bold",
            float: "right",
            marginBottom: 100,
            marginRight: 42,
          }}
          onClick={() => {
            handleFinish();
          }}
        >
          {showDiscountedPrice
            ? "Poslat si set e-mailem"
            : "Zjistit cenu setu po slevě"}
        </div>

        {props.changeStepButton()}
      </div>
    );
  }

  function handleFinish() {
    if (!showDiscountedPrice && !showEmailForm) {
      finish();
    }

    if (showDiscountedPrice) {
      setShowEmailForm(true);
    }
    setShowDiscountedPrice(true);
  }

  function finish() {
    $.post(
      "/tvorba-setu-spotrebicu/finish",
      {
        total_price: props.discountedTotalPrice,
        total_price_without_discount: props.totalPrice,
      },
      function (data) {
        window.history.pushState("", "", "/tvorba-setu/zobrazit/" + data.token);
        trackPageview("/tvorba-setu/zobrazit/" + data.token);
      }.bind(this)
    );
  }

  return (
    <div>
      <SummaryOverviewItems
        items={props.items}
        totalPrice={formatMoney(props.totalPrice)}
        discountedTotalPrice={formatMoney(props.discountedTotalPrice)}
        removeFromCategorySelection={props.removeFromCategorySelection}
        removeImageUrl={props.removeImageUrl}
        showDiscountedPrice={showDiscountedPrice}
        totalDiscount={props.totalDiscount}
        handleQuantityChange={props.handleQuantityChange}
      />

      {!showEmailForm ? finishButton() : null}
      {showEmailForm ? form() : null}
    </div>
  );
};
